import { Fade, Stack, styled } from '@mui/material'
import clsx from 'clsx'
import { atom, useAtom, useSetAtom } from 'jotai'
import { memo, useRef } from 'react'
import { TokenSymbol } from 'types'
import { useOnClickOutside } from 'usehooks-ts'
import { ReactComponent as ArrowSelectedSvg } from './selected.svg'
import { ReactComponent as ArrowSvg } from './arrow.svg'

const StyledSelectCurrency = styled(Stack)`
  font-size: 14px;
  position: relative;
`
const CurrentCurrency = styled(Stack)<{ in: number }>`
  flex-direction: row;
  align-items: center;
  color: ${(props) => props.theme.color.text50};
  font-weight: 600;
  cursor: pointer;

  svg.arrow {
    margin-left: 3px;
    transition: all 0.4s ease;
    color: ${(props) =>
      props.in === 1 ? 'rgba(160,238,9,1)' : 'rgba(149,164,173,1)'};
    transform: ${(props) =>
      props.in === 1 ? 'rotate(0deg)' : 'rotate(180deg)'};
  }
`
const Popup = styled(Stack)`
  position: absolute;
  top: calc(100% + 13px);
  right: -5px;
  padding: 8px;
  width: 106px;
  border-radius: 4px;
  z-index: 2;
  background: #1e2329;
  border: 1px solid #2a3139;
`
const PopupOption = styled('div')`
  padding: 6px 8px;
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;
  line-height: 1.4;
  font-size: 14px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: rgba(229, 234, 238, 1);
  margin-bottom: 8px;
  &:last-child {
    margin-bottom: 0px;
  }
  svg {
    display: none;
  }

  &:hover {
    background-color: rgba(42, 49, 57, 1);
    border-radius: 4px;
  }
  &.active {
    font-weight: 600;
    color: ${({ theme }) => theme.palette.primary.main};
    cursor: default;
    svg {
      display: block;
    }
  }
`

export const selectedCurrencyAtom = atom<TokenSymbol>('')
export const selectCurrencyPopupAtom = atom<boolean>(false)

export const PlaceOrderCurrencySelection = memo<{
  currentCurrency: TokenSymbol
  baseCurrency: TokenSymbol
  quoteCurrency: TokenSymbol
}>(({ currentCurrency, baseCurrency, quoteCurrency }) => {
  const currencies = [baseCurrency, quoteCurrency]
  const setCurrentCurrency = useSetAtom(selectedCurrencyAtom)
  const [visible, setVisible] = useAtom(selectCurrencyPopupAtom)
  const ref = useRef(null)
  useOnClickOutside(ref, () => setVisible(false))

  return (
    <StyledSelectCurrency ref={ref}>
      <CurrentCurrency onClick={() => setVisible(true)} in={visible ? 1 : 0}>
        {currentCurrency}
        <ArrowSvg className="arrow" />
        {/* <Iconfont name="icon-Down" size={12} /> */}
      </CurrentCurrency>
      <Fade in={visible}>
        <Popup>
          {currencies.map((currency) => {
            return (
              <PopupOption
                key={currency}
                className={clsx({ active: currency === currentCurrency })}
                onClick={() => {
                  setCurrentCurrency(currency)
                  setVisible(false)
                }}
              >
                {currency}
                <ArrowSelectedSvg />
              </PopupOption>
            )
          })}
        </Popup>
      </Fade>
    </StyledSelectCurrency>
  )
})
